"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = openModal;
exports.closeModal = closeModal;
exports.closeAllModals = closeAllModals;

var _ = require("./");

/**
 * Opens specific modal dialog
 *
 * TODO: specify the full list of possible values for "modal" parameter
 *
 * @param {string} modal
 * @returns {{type, payload: *}}
 */
function openModal(modal) {
  return {
    type: _.OPEN_MODAL,
    payload: modal
  };
}
/**
 * Closes specific modal dialog
 *
 * TODO: specify the full list of possible values for "modal" parameter
 *
 * @param {string} modal
 * @returns {{type, payload: *}}
 */


function closeModal(modal) {
  return {
    type: _.CLOSE_MODAL,
    payload: modal
  };
}
/**
 * Closes all modal dialogs
 *
 * @returns {{type}}
 */


function closeAllModals() {
  return {
    type: _.CLOSE_ALL_MODALS
  };
}